<template>
  <div id="app">
    <router-view></router-view>
    <NoMobileNoticeDialog />
  </div>
</template>

<script>
import NoMobileNoticeDialog from "@/components/NoMobileNoticeDialog.vue";

export default {
  name: "App",
  components: {
    NoMobileNoticeDialog,
  },
};
</script>

<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ffaa00;
}
.el-pager li:hover {
  color: #ffaa00;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ffaa00;
}
</style>
